import React, { useState } from 'react';
import { resetPasswordRequest } from '../api/auth';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './auth.css';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Email is required');
      return;
    }
    setLoading(true);
    try {
      await resetPasswordRequest(email);
      toast.success('If the email exists, instructions have been sent');
      navigate('/login');
    } catch (err) {
      const msg = err.response?.data?.message || 'Request failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <ToastContainer />
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2>Password Reset</h2>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? 'Please wait...' : 'Send reset link'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
